import { Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, AfterViewInit } from '@angular/core';
import { deepCopy } from '@delon/util';
import { DndDropEvent, DropEffect } from '../../../ngx-drag-drop';
import { IComponentDef } from '../../../shared/interfaces';
import { WidgetFormRenderBase } from '../widget-form-render-base';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[d-widget-form-render]',
  templateUrl: './d-widget-form-render.component.html',
  styleUrls: ['./d-widget-form-render.component.less']
})
export class DWidgetFormRenderComponent extends WidgetFormRenderBase {
  constructor(injector: Injector) {
    super(injector);
  }
}
